<template>
  <Popup :customClasses="customClasses" :modelValue="modelValue" :popupHeader="popupHeader" @update:modelValue="input">
    <p v-if="popupMessage" class="mb-16">{{ popupMessage }}</p>
    <Button :loading="loadingState" :value="discardBtnText" class="w-full mb-16" @click="discard" />
    <Button value="Cancel" class="w-full" variant="outlined" @click="cancel" />
  </Popup>
</template>

<script lang="ts">
import Popup from '@/components/popup/Popup.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'DiscardPopup',
  components: { Popup, Button },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    popupHeader: {
      type: String,
      required: false,
      default: 'Discard draft?',
    },
    popupMessage: {
      type: String,
      required: false,
      default: '',
    },
    discardBtnText: {
      type: String,
      required: false,
      default: 'Discard',
    },
    mobileAlignBottom: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadingState: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    customClasses(): string {
      return this.mobileAlignBottom ? '' : 'bottom-80';
    },
  },
  methods: {
    input(value: boolean): void {
      this.$emit('update:modelValue', value);
    },
    discard(): void {
      this.$emit('discard');
    },
    cancel(): void {
      this.$emit('cancel');
    },
  },
};
</script>
